import * as parking_property_filder from "./parking_propery_finder.js";
import * as _ from "lodash";

export default {
  getTaxiPopup(feature, data_popup) {
    var html = "";

    html =
      '<div class="item test-bg item-divider">' + data_popup.name1 + "</div>";

    html +=
      '<div class="popup-line item item-icon-right" data-lineId="' +
      feature.properties.kategoria +
      '">' +
      feature.properties.notes +
      "</div>";

    html = '<div class="list "> ' + html + " </div>";
    return html;
  },

  getParkingPoupup(feature, map_data) {
    var html = "";
    var categoryid = feature.properties.kategoria;
    var category = map_data.kategorite["kategori_" + categoryid];

    var metaid = feature.properties.metaid;
    var meta = map_data.metadata["meta_" + metaid];

    /* Properties */
    var zap = parking_property_filder.propertyByFeature(
      feature,
      "zap",
      map_data
    );

    var rruga = parking_property_filder.propertyByFeature(
      feature,
      "rruga",
      map_data
    );

    var color = parking_property_filder.propertyByFeature(
      feature,
      "color",
      map_data
    );

    var price = parking_property_filder.propertyByFeature(
      feature,
      "price",
      map_data
    );

    var free = parking_property_filder.propertyByFeature(
      feature,
      "free",
      map_data
    );

    var paid = parking_property_filder.propertyByFeature(
      feature,
      "paid",
      map_data
    );

    var capacity = parking_property_filder.propertyByFeature(
      feature,
      "capacity",
      map_data
    );

    var description = parking_property_filder.propertyByFeature(
      feature,
      "description",
      map_data
    );

    /* parkim rruge */
    if (description) {
      var pretitle = "";
      if (zap) {
        pretitle +=
          '<span  class="bold" style="color: ' +
          color +
          ' ;">' +
          zap +
          ": </span>";
      }
      pretitle += rruga;
      var parkingInfo = "";
      if (capacity) {
        parkingInfo +=
          '<div class="popup-line pad_v item"><div style="color: ' +
          color +
          ' ;">' +
          '</div> <div class="pad_v_half" style="white-space:normal;">' +
          capacity +
          "</div></div>";
      }
      if (description) {
        parkingInfo +=
          '<div class="popup-line pad_v item"><div style="color: ' +
          color +
          ' ;">' +
          '</div> <div class="pad_v_half" style="white-space:normal;">' +
          description +
          "</div></div>";
      }
    } else {
      var pretitle =
        '<span class="bold" style="color: ' +
        color +
        ' ;">ZAP ' +
        zap +
        ": </span>" +
        rruga;
      var parkingInfo = "";

      if (free) {
        parkingInfo +=
          '<div class="popup-line  pad_v item">' +
          "parkingfree" +
          ' <span class="item-note">' +
          free +
          "</span></div>";
      }

      if (paid) {
        parkingInfo +=
          '<div class="popup-line  pad_v item">' +
          "parkingpaid" +
          ' <span class="item-note">' +
          paid +
          "</span></div>";
      }

      if (capacity) {
        parkingInfo +=
          '<div class="popup-line pad_v item">' +
          "capacity" +
          '<span class="item-note">' +
          capacity +
          "</span></div>";
      }
    }

    if (pretitle) {
      html += '<div class="item item-divider">' + pretitle + "</div>";
    }

    var parkingtype = parking_property_filder.propertyByFeature(
      feature,
      "parkingtype",
      map_data
    );
    if (parkingtype) {
      html += '<div class="popup-line pad_v item">' + parkingtype + "</div>";
    }

    if (price.length) {
      html += '<div class="popup-line pad_v item">' + "price_range" + "</div>";
      _.each(price, function(val, i) {
        html +=
          '<div class="pad_double pad_v-half grid_50 fl_right font_16 txt_center" style="clear: right;">' +
          val.nr_ore +
          '<span class="item-note color lblue">' +
          val.cmimi +
          " " +
          val.monedha +
          "</span></div>";
      });
    }

    if (parkingInfo) {
      html += parkingInfo;
    }

    html +=
      '<div class="popup-line pad_v item parking-load" style="display:none;"></div>';

    html = '<div class="list " id="popupParking"> ' + html + " </div>";
    return html;
  },

  getBicyclePoupup(feature) {
    var html =
      '<div class="item item-divider">' + feature.properties.name + "</div>";
    html +=
      '<div class="item popup-line">Numri <span class="item-note">' +
      feature.properties.numri +
      "</span></div>";
    return html;
  },

  getTurisemPopup(feature, map_data) {
    var icon_url = map_data.kategorite.filter(el => {
      return el.id == feature.properties.category_id;
    })[0].icon;

    var html = "";
    if (feature.properties.poi_title) {
      html +=
        '<div  class="item item-divider">' +
        feature.properties.poi_title +
        '<span class="link-icon">&#8618;</span></div>';
    }
    var avatarClass = "",
      avatarBg = "";
    if (feature.properties.poi_simg_src) {
      avatarClass = "item-avatar";
      avatarBg =
        '<div class="turizem-popup-img" style="background-image: url(' +
        feature.properties.poi_simg_src +
        ");></div>";
    }

    html +=
      '<div class="">' +
      avatarBg +
      '<div class="font_20 pad_v  ">' +
      '</div><div class="turizem-desc">' +
      feature.properties.poi_desc +
      "</div></div>";

    if (!html) {
      html = '<div class="item item-divider"> Nuk ka te dhena' + "</div>";
    }

    html =
      '<div id="data_popup" data-turisemel="false" data-icon="' +
      icon_url +
      '" data-popup="' +
      feature.properties.poi_id +
      '" class="list "> ' +
      html +
      " </div>";

    return html;
  },

  getTransportType(feature, map_data) {
    var html = "",
      lineIds = [],
      i = 1,
      j = 0;

    if (feature.properties.emri) {
      html =
        '<div class="item  item-divider">' + feature.properties.emri + "</div>";
    }

    for (var i = 1; i < 6; i++) {
      if (feature.properties["LINJA_" + i]) {
        lineIds.push(feature.properties["LINJA_" + i]);
        html +=
          '<div class="popup-line item item-icon-right" data-lineId="' +
          feature.properties["LINJA_" + i] +
          '"> <span class="line-label" style="color: ' +
          map_data.ngjyrat[feature.properties["LINJA_" + i]] +
          ' ">' +
          feature.properties["LINJA_" + i] +
          "</span>  " +
          map_data.emrat[feature.properties["LINJA_" + i]] +
          '<i class="icon ion-arrow-right-c"></i> </div>';
      }
    }

    if (!html) {
      html = '<div class="item item-divider">' + "N/A" + "</div>";
    }

    html = '<div class="list "> ' + html + " </div>";
    return html;
  },

  getAdministativeUnitPopup(data_popup, layer_or_marker) {
    if (layer_or_marker == 2) {
      var html = [
        '<div class="item item-divider">Njësia: ' +
          (data_popup.feature.properties.njesia ||
            data_popup.feature.properties.emertim_ko ||
            "N/A") +
          "</div>"
      ];
      if (data_popup.feature.properties.Population) {
        html.push(
          '<div class="item popup-line pad_v">Popullsia: <span class="item-note">' +
            data_popup.feature.properties.Population +
            "</span></div>"
        );
      }
      if (data_popup.feature.properties.Buildings) {
        html.push(
          '<div class="item popup-line pad_v">Ndërtesa: <span class="item-note">' +
            data_popup.feature.properties.Buildings +
            "</span></div>"
        );
      }
      if (data_popup.feature.properties.Dwellings) {
        html.push(
          '<div class="item popup-line pad_v">Banesa: <span class="item-note">' +
            data_popup.feature.properties.Dwellings +
            "</span></div>"
        );
      }
      if (data_popup.feature.properties.Adresa) {
        html.push(
          '<div class="item popup-line pad_v">Adresa: <span class="item-note">' +
            data_popup.feature.properties.Adresa +
            "</span></div>"
        );
      }
      if (data_popup.feature.properties.email) {
        html.push(
          '<a class="item popup-line pad_v" href="mailto:' +
            data_popup.feature.properties.email +
            '">E-mail: <span class="item-note">' +
            data_popup.feature.properties.email +
            "</span></a>"
        );
      }
      if (data_popup.feature.properties.tel) {
        html.push(
          '<a class="item popup-line pad_v" href="tel:' +
            data_popup.feature.properties.tel +
            '">Tel: <span class="item-note">' +
            data_popup.feature.properties.tel +
            "</span></a>"
        );
      }
      if (data_popup.feature.properties.tel1) {
        html.push(
          '<a class="item popup-line pad_v" href="tel:' +
            data_popup.feature.properties.tel1 +
            '">Tel: <span class="item-note">' +
            data_popup.feature.properties.tel1 +
            "</span></a>"
        );
      }
      if (data_popup.feature.properties.tel2) {
        html.push(
          '<a class="item popup-line pad_v" href="tel:' +
            data_popup.feature.properties.tel2 +
            '">Tel: <span class="item-note">' +
            data_popup.feature.properties.tel2 +
            "</span></a>"
        );
      }

      return '<div class="list "> ' + html.join("") + " </div>";
    } else {
      return (
        '<div class="item  popup-line item-divider">' +
        data_popup.properties.emertim_ko +
        "</div>"
      );
    }
  },

  getTraficViewPopup(feature) {
    var imgSrc = feature.properties.img;
    return (
      '<div>\n <div class="bg violet marker_popup_bg" data-img="' +
      imgSrc +
      '" style="width:352px;height:288px;max-width: 100%;\n background-image: url(' +
      imgSrc +
      ');"></div>\n<div class="font_18 popup-line pad_double pad_v_double">' +
      feature.properties.address +
      '<button class="cctv_popup_close bg violet button button-fab button-fab-bottom-right icon ion-android-close"></button></div>\n</div>'
    );
  },

  getShkollatComunity(feature, name) {
    return (
      '<div id="data_popup" class="item" data-popup="' +
      feature.properties.poi_id +
      '">' +
      '<div class="category item-divider">' +
      name +
      "</div>" +
      '<div class="item popup-line">' +
      feature.properties.poi_title +
      "</div>" +
      "</div>"
    );
  },

  getAdressLiveTrafic(feature) {
    return "";
  }
};
